import React from 'react';
import { BarChart3 } from 'lucide-react';

export interface PublicPageStateProps {
  title: string;
  description: string;
}

export const PublicPageState: React.FC<PublicPageStateProps> = ({ title, description }) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md rounded-xl border border-gray-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-purple-50">
          <BarChart3 className="h-6 w-6 text-purple-600" />
        </div>
        <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
        <p className="mt-2 text-sm text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default PublicPageState;
